import { useTranslation } from 'react-i18next'

import styles from './OccupanciesTab.module.scss'

const OccupanciesTab = ({ occupancies, setPaying, evictOne }) => {
  const { t } = useTranslation('common')

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th>{t('dorm.col_student')}</th>
          <th>{t('dorm.col_room')}</th>
          <th>{t('dorm.col_from')}</th>
          <th>{t('dorm.col_until')}</th>
          <th>{t('dorm.col_contract')}</th>
          <th>{t('dorm.col_payment')}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {occupancies.map((o) => (
          <tr key={o.id}>
            <td>{o.student_label}</td>
            <td>{o.room_label}</td>
            <td>{o.since}</td>
            <td>{o.until || '—'}</td>
            <td>{o.contract_no || '—'}</td>
            <td>{o.monthly_payment}</td>
            <td>
              <button
                className={styles.smallBtn}
                onClick={() =>
                  setPaying({
                    occupancy: o.id,
                    period_year: new Date().getFullYear(),
                    period_month: new Date().getMonth() + 1,
                    amount: o.monthly_payment,
                  })
                }
              >
                {t('dorm.pay_btn')}
              </button>
              {!o.until && (
                <button className={styles.smallBtn} onClick={() => evictOne(o.id)}>
                  {t('dorm.evict_btn')}
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default OccupanciesTab
